import * as _ from "lodash";
import * as actions from "products/widgets/actions";
import { initialWidget } from "products/widgets/Widget";
//-- Reducer -------------------------------------------------------------------------------------------------------------------------------
export default function widgetReducer(currState = initialWidget, baseAction) {
    let stateChanges;
    switch (baseAction.type) {
        case actions.SET_FEATURED_AGENT:
            const featuredAgentAction = baseAction;
            stateChanges = {
                featuredAgentUrl: featuredAgentAction.url
            };
            return _.assign({}, currState, stateChanges);
        case actions.SET_FEATURED_LISTING:
            let featuredListingAction = baseAction;
            stateChanges = {
                featuredListingUrl: featuredListingAction.url
            };
            return _.assign({}, currState, stateChanges);
        case actions.SET_SPOTLIGHT_LISTING:
            let spotlightListingAction = baseAction;
            stateChanges = {
                spotlightListingUrl: spotlightListingAction.url
            };
            return _.assign({}, currState, stateChanges);
    }
    return currState;
}
